import script from "./SolarSystem.vue?vue&type=script&setup=true&lang=ts"
export * from "./SolarSystem.vue?vue&type=script&setup=true&lang=ts"

import "./SolarSystem.vue?vue&type=style&index=0&id=64e517cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64e517cc"]])

export default __exports__